export default function FlightSegmentAlternativesService(
    flightRecommendationService,
    flightSegmentService,
    flightGroupService
) {
    'ngInject';

    Object.assign(this, {
        doesOverlapSiblingSegments,
        doesOverlapPreviousSegment,
    });

    function doesOverlapSiblingSegments(recommendation, segment, group, selectedFlights) {
        return doesOverlapPreviousSegment(recommendation, segment, group, selectedFlights)
            || doesOverlapNextSegment(recommendation, segment, group, selectedFlights);
    }

    function doesOverlapPreviousSegment(recommendation, segment, group, selectedFlights) {
        if (flightRecommendationService.isOneWayTrip(recommendation)) {
            return false;
        }

        const previousSegment = flightSegmentService.getPreviousSegment(recommendation, segment);
        if (!previousSegment) {
            return false;
        }

        const returnFlight = flightGroupService.getFirstFlight(group);
        const departureDate = returnFlight.DepartureDate;

        const previousGroup = flightSegmentService.getSelectedGroup(selectedFlights, previousSegment);
        const previousFlight = flightGroupService.getLastFlight(previousGroup);
        const arrivalDate = previousFlight.ArrivalDate;

        return new Date(arrivalDate) > new Date(departureDate);
    }

    function doesOverlapNextSegment(recommendation, segment, group, selectedFlights) {
        if (flightRecommendationService.isOneWayTrip(recommendation)) {
            return false;
        }

        const nextSegment = flightSegmentService.getNextSegment(recommendation, segment);
        if (!nextSegment) {
            return false;
        }

        const outwardFlight = flightGroupService.getLastFlight(group);
        const arrivalDate = outwardFlight.ArrivalDate;

        const nextGroup = flightSegmentService.getSelectedGroup(selectedFlights, nextSegment);
        const nextFlight = flightGroupService.getFirstFlight(nextGroup);
        const departureDate = nextFlight.DepartureDate;

        return new Date(arrivalDate) > new Date(departureDate);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-segment-alternatives/flight-segment-alternatives-service.js